<template>
  <div class="measureTab">
    <van-tabs v-model="active">
      <van-tab title="防水" name="1" class="waterprooof">
        <template #default>
          <div v-if="waterproofJson">
              <div class="measureData" v-for="(item,index) in waterproofJson.datalist" :key="index">
              <div class="titleWrapper">
                <span class="title">测量位置：</span><span class="values">{{item.optName}}</span>
              </div>
              <div class="borderWrapper">
                <div>
                  <span>名称</span>
                  <span>长度</span>
                  <span>宽度</span>
                  <span>面积</span>
                </div>
                <div v-for="(items,indexs) in item.child" :key="indexs">
                  <span>{{items.name}}</span>
                  <span>{{items.height}} m</span>
                  <span>{{items.width}} m</span>
                  <span>{{items.area}} ㎡</span>
                </div>
              </div>
              <div class="titleWrapper">
                <span class="title">测量面积：</span><span class="values">{{item.czarea}} ㎡</span>
              </div>
            </div>
            <div class="measureData">
              <div class="titleWrapper bottom_border">
                <span class="title">防水总面积：</span>
                <span class="values">{{waterproofJson.zarea}} ㎡</span>
              </div>
              <div class="titleWrapper bottom_border">
                <span class="title">施工方案：</span>
                <span class="values" v-if="waterproofJson.schemea">{{waterproofJson.schemea.schemeName}}</span>
              </div>
<!--              <div class="infoWrapper">-->
<!--                <p>{{waterproofJson.schemeaTxt}}</p>-->
<!--              </div>-->
            </div>
            <div class="measureData measureDataMargin" v-if="waterproofJson.ttype=='1'">
              <div class="titleWrapper bottom_border">
                <span class="title">质保年限：</span><span class="values">{{waterproofJson.waterproofKey}}</span>
              </div>
            </div>
            <div class="measureData measureDataMargin">
              <div class="titleWrapper">
                <span class="title">防水费用：</span><span class="values">{{waterproofJson.zprice}}元</span>
              </div>
            </div>
          </div>
          <noData v-else></noData>
        </template>
      </van-tab>
      <van-tab title="服务人员" name="2" class="waterprooof">
        <div v-if="serviceStaff">
          <div class="measureData">
            <div class="borderWrapper">
              <div>
                <span>姓名</span>
                <span>电话</span>
              </div>
              <div v-for="(items,indexs) in serviceStaff" :key="indexs">
                <span>{{items.name}}</span>
                <span>{{items.phone}}</span>
              </div>
            </div>
          </div>
        </div>
        <noData v-else></noData>
      </van-tab>
<!--      <van-tab title="电工" name="2" class="waterprooof">-->
<!--        <template #default>-->
<!--          <div v-if="electricianJson">-->
<!--            <div class="measureData" v-for="(item,index) in electricianJson.datalist" :key="index">-->
<!--              <div class="titleWrapper">-->
<!--                <span class="title">测量位置：</span><span class="values">{{item.optName}}</span>-->
<!--              </div>-->
<!--              <div class="borderWrapper">-->
<!--                <div>-->
<!--                  <span>名称</span>-->
<!--                  <span>长度</span>-->
<!--                  <span>宽度</span>-->
<!--                  <span>面积</span>-->
<!--                </div>-->
<!--                <div v-for="(items,indexs) in item.child" :key="indexs">-->
<!--                  <span>{{items.name}}</span>-->
<!--                  <span>{{items.height}} m</span>-->
<!--                  <span>{{items.width}} m</span>-->
<!--                  <span>{{items.area}} ㎡</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="titleWrapper">-->
<!--                <span class="title">测量面积：</span><span class="values">{{item.czarea}} ㎡</span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="measureData">-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">电工总面积：</span><span class="values">{{electricianJson.zarea}} ㎡</span>-->
<!--              </div>-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">施工方案：</span><span class="values">{{electricianJson.schemea.schemeName}}</span>-->
<!--              </div>-->
<!--              <div class="infoWrapper">-->
<!--                <p>{{electricianJson.schemeaTxt}}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="measureData measureDataMargin" v-if="electricianJson.ttype=='1'">-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">质保年限：</span><span class="values">{{electricianJson.electricianKey}}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="measureData measureDataMargin">-->
<!--              <div class="titleWrapper">-->
<!--                <span class="title">电工费用：</span><span class="values">{{electricianJson.zprice}}元</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <noData v-else></noData>-->
<!--        </template>-->
<!--      </van-tab>-->
<!--      <van-tab title="给排水" name="3" class="waterprooof">-->
<!--        <template #default>-->
<!--          -->
<!--          <div v-if="drainageJson">-->
<!--            <div class="measureData" v-for="(item,index) in drainageJson.datalist" :key="index">-->
<!--              <div class="titleWrapper">-->
<!--                <span class="title">测量位置：</span><span class="values">{{item.optName}}</span>-->
<!--              </div>-->
<!--              <div class="borderWrapper">-->
<!--                <div>-->
<!--                  <span>名称</span>-->
<!--                  <span>长度</span>-->
<!--                  <span>宽度</span>-->
<!--                  <span>面积</span>-->
<!--                </div>-->
<!--                <div v-for="(items,indexs) in item.child" :key="indexs">-->
<!--                  <span>{{items.name}}</span>-->
<!--                  <span>{{items.height}} m</span>-->
<!--                  <span>{{items.width}} m</span>-->
<!--                  <span>{{items.area}} ㎡</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="titleWrapper">-->
<!--                <span class="title">测量面积：</span><span class="values">{{item.czarea}} ㎡</span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="measureData">-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">排水总面积：</span><span class="values">{{drainageJson.zarea}}㎡</span>-->
<!--              </div>-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">施工方案：</span><span class="values">{{drainageJson.schemea.schemeName}}</span>-->
<!--              </div>-->
<!--              <div class="infoWrapper">-->
<!--                <p>{{drainageJson.schemeaTxt}}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash; <div class="measureData measureDataMargin">-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">质保年限：</span><span class="values">{{waterproofJson.zprice}}</span>-->
<!--              </div>-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">人工费用：</span><span class="values">{{drainageJson.zprice}}</span>-->
<!--              </div>-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">排水费用：</span><span class="values">{{waterproofJson.zprice}}</span>-->
<!--              </div>-->
<!--            </div> &ndash;&gt;-->
<!--            <div class="measureData measureDataMargin" v-if="drainageJson.ttype=='1'">-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">质保年限：</span><span class="values">{{drainageJson.drainageKey}}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="measureData measureDataMargin">-->
<!--              <div class="titleWrapper">-->
<!--                <span class="title">排水费用：</span><span class="values">{{drainageJson.zprice}}元</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <noData v-else></noData>-->
<!--        </template>-->
<!--      </van-tab>-->
<!--      <van-tab title="其他" name="4" class="waterprooof">-->
<!--        <template #default>-->
<!--          -->
<!--          <div v-if="otherJson">-->
<!--            <div class="measureData" v-for="(item,index) in otherJson.datalist" :key="index">-->
<!--              <div class="titleWrapper">-->
<!--                <span class="title">测量位置：</span><span class="values">{{item.optName}}</span>-->
<!--              </div>-->
<!--              <div class="borderWrapper">-->
<!--                <div>-->
<!--                  <span>名称</span>-->
<!--                  <span>长度</span>-->
<!--                  <span>宽度</span>-->
<!--                  <span>面积</span>-->
<!--                </div>-->
<!--                <div v-for="(items,indexs) in item.child" :key="indexs">-->
<!--                  <span>{{items.name}}</span>-->
<!--                  <span>{{items.height}} m</span>-->
<!--                  <span>{{items.width}} m</span>-->
<!--                  <span>{{items.area}} ㎡</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="titleWrapper">-->
<!--                <span class="title">测量面积：</span><span class="values">{{item.czarea}} ㎡</span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="measureData">-->
<!--              <div class="titleWrapper bottom_border">-->
<!--                <span class="title">墙体总面积：</span><span class="values">{{otherJson.zarea}} ㎡</span>-->
<!--              </div>-->
<!--              <div v-for="(item,index) in otherJson.schemeList" :key="index">-->
<!--                <div class="titleWrapper bottom_border">-->
<!--                  <span class="title">施工方案：</span><span class="values">{{item.schemea.schemeName}}</span>-->
<!--                </div>-->
<!--                <div class="infoWrapper">-->
<!--                  <p>{{item.schemeaTxt}}</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="measureData measureDataMargin">-->
<!--              <div class="titleWrapper">-->
<!--                <span class="title">其它费用：</span><span class="values">{{otherJson.zprice}}元</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <noData v-else></noData>-->
<!--        </template>-->
<!--      </van-tab>-->
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: 'measureTab',
  data () {
    return {
      active:1
    }
  },
  props:{
    waterproofJson:{
      type:Object,
      default:() => {
        return null
      },
    },
    electricianJson:{
      type:Object,
      default:() => {
        return null
      },
    },
    drainageJson:{
      type:Object,
      default:() => {
        return null
      },
    },
    otherJson:{
      type:Object,
      default:() => {
        return null
      },
    },
    serviceStaff:{
      type:Array,
      default:() => {
        return []
      },
    }
  },
  mounted(){
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.measureTab{
  .titleWrapper{
    padding:12px 10px 12px 0;
    margin-left:10px;
    color:#000000;
    .title{
      font-size: 15px;
      font-weight: bolder;
      display: inline-block;
      min-width: 75px;
    }
    .values{
      font-size: 14px;
    }
  }
  .van-cell__title{
    .circle{
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #65A1FF;
      margin-right: 8px;
      vertical-align: middle;
    }
    .sideBarTitle{
      color: #000000;
      font-size: 14px;
      vertical-align: middle;
      font-weight: bold;
    }
  }
  .van-collapse-item__content{
    .noData{
      text-align: center;
      margin:20px 0;
    }
  }
  .waterprooof{
    .measureData{
      background: #F7F7F7;
      margin-bottom: 7px;
      border-radius: 3px;
    }
    .measureDataMargin{
      margin-bottom:0;
    }
    .whiteMeasuerData{
      // margin-bottom: 7px;
    }
    .measureData,.whiteMeasuerData,.lastMeasureData{
      color:#000000;
      .titleWrapperMargin{
        margin-left:0;
      }
      .infoWrapper{
        padding:15px;
        p{
          color:#888888;
          font-size: 14px;
        }
      }
      .borderWrapper{
        border: 1px solid #EBEBEB;
        margin:0 9px;
        border-radius: 5px;
        div{
          display: flex;
          justify-content: space-around;
          margin: 16px 0;
          span{
            width: 25%;
            text-align: center;
            font-size: 14px;
          }
          &:last-child{
            span{
              color:#888888;
            }
          }
        }
      }

    }
    .bgWrapper{
      background: #F7F7F7;
      .items{
        padding:15px 0;
        display: flex;
        justify-content: space-around;
        span{
          flex: 1;
          text-align: center;
        }
      }
    }
  }
  .pay{
    padding-bottom:15px;
  }
  .bottom_border{
    border-bottom: 1px solid #EBEBEB;
  }
}
</style>
<style lang="less">
.measureTab{
  .van-collapse-item{
    .van-cell{
      padding-top:8px;
      padding-bottom:8px;
    }
  }
  /deep/ .van-collapse-item__title{
    background:#fafafa;
  }
  .van-tabs__line{
    display: none;
  }
  .van-tab__text{
    font-size:14px;
    color:rgba(184, 184, 184, 1);
    border-bottom:4px solid transparent;
  }
  .van-tab--active{
    .van-tab__text{
      color:#65A1FF;
      border-bottom:4px solid #65A1FF;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/measureTab.vue